import { PartnerType } from 'js/common/types/billing';

export enum SignupMethod {
  FORM = 'form',
  GOOGLE = 'google',
}

export enum SignupSource {
  ACCOUNT = 'Account',
  AWS_MARKETPLACE = 'AwsMarketplace',
  GCP_MARKETPLACE = 'GcpMarketplace',
  VERCEL = 'Vercel',
}

export function getSignUpSource(
  signupType: PartnerType | undefined | null,
  isVercelIntegration: boolean | undefined | null = false
) {
  if (isVercelIntegration) {
    return SignupSource.VERCEL;
  }
  switch (signupType) {
    case PartnerType.AWS:
      return SignupSource.AWS_MARKETPLACE;
    case PartnerType.GCP:
      return SignupSource.GCP_MARKETPLACE;
    default:
      return SignupSource.ACCOUNT;
  }
}
